<template>
    <div class="step-container">
        <div class="logo-top">
            <img src="./../assets/image/logo.png" alt="logo">
        </div>

        <div v-if="step1">
            <!-- <img src="./../assets/image/ALC-logo-MT.png" alt="logo" style="width: 40%; margin: auto; display: block; margin-top: 99px; margin-bottom: 44px;"> -->
            <div class="top-image step1"></div>

            <div class="step-content">
                <h3>Indtast din nøgle</h3>
                <p>For at kunne finde ud af hvilken forsyning, som du hører til, skal vi bruge en nøgle. Tryk på knappen nedenfor for at validere nøglen.</p>
                <input type="text" v-model="key" placeholder="Nøgle">
                <a class="button" style="max-height: 38px; height: 38px" @click="validateKey">
                    <span v-if="!downloading">Validér nøgle</span>
                    <span v-if="downloading"><div class="loading-spinner"></div> &nbsp; Validerer...</span>
                </a>
                <p class="error">{{errorMessage}}</p>
            </div>
        </div>

        <div v-if="step2">
            <div class="top-image step2"></div>

            <div class="step-content">
                <h3>Vælg montør</h3>
                <p>For at optimere din brugeroplevelse og sikre korrekt data, skal du fortælle os, hvem du er. Dette gøres i dropdown-feltet nedenfor.</p>
                <select v-model="selected">
                    <option disabled value="0" selected="selected">Vælg en montør</option>
                    <option v-for="option in options" v-bind:value="option" v-bind:key="option">
                        {{option.navn}}
                    </option>
                </select>
                <a class="button" :class="{disabled: empty}" @click="chooseUser">Næste</a>
                <p class="error">{{errorMessage}}</p>
            </div>
            <p class="goback" @click="gotoStep1">
                <i class="material-icons">arrow_back</i> 
                Tilbage
            </p>
        </div>

        <div v-if="step3">
            <div class="top-image step3"></div>

            <div class="step-content">
                <h3>Hent app'en og kom i gang</h3>
                <p>Du er nu klar til at komme i gang. Tryk på knappen nedenfor for at hente nødvendige data ned på din enhed, så det fungerer uden internet og sikrer en bedre brugeroplevelse</p>
                <a class="button" @click="getServerData">Hent app</a>
                <p class="error">{{errorMessage}}</p>
            </div>
            <p class="goback" @click="gotoStep2">
                <i class="material-icons">arrow_back</i> 
                Tilbage
            </p>
        </div>

        <div class="loading-overlay" v-if="showLoader">
			<div class="counter">
                <div v-if="errorMessage.length == 0">
                    <h3>Installerer MålerTjek-app'en <span class="loading-overview"><span>.</span><span>.</span><span>.</span></span></h3>
                     <!--<p>Trin {{activeStep}} af {{totalSteps}}</p>-->
                    <p class="small-text-loading">{{message}}</p>
				</div>
                <div v-if="errorMessage.length > 0">
                    {{errorMessage}}
                    <a class="button error-button" @click="closeError">Okay</a>
                </div>
			</div>
		</div>

        <div class="steps">
            <ul>
                <li :class="{active: step1}"></li>
                <li :class="{active: step2}"></li>
                <li :class="{active: step3}"></li>
            </ul>
        </div>
    </div>
</template>

<script>

import DAL, {mongoObjectId} from './../js/Sync/dal';
import clearQueue from './../js/Sync/clearQueue';
import zango from 'zangodb';

export default {
    name: 'init',
    data() {
        return {
            step1: true,
            step2: false,
            step3: false,
            //key: '58255dfc-7963-46f5-9001-302da1f70327',
            //key: 'DBB06AEE-989F-4F9E-847A-DC5C97FAA94A',
            key: '',
            validated: false,
            user: '',
            selected: '',
            errorMessage: '',
            options: [],
            empty: true,
            showLoader: false,
            activeStep: 0,
            totalSteps: 1,
            downloading: false,
            url: '',
            message: ''
        }
    },
    methods: {
        gotoStep2() {
            this.step1 = false;
            this.step2 = true;
            this.step3 = false;
            this.errorMessage = "";
        },
        gotoStep1() {
            this.step1 = true;
            this.step2 = false;
            this.step3 = false;
            this.errorMessage = "";
        },
        validateKey() {
            this.downloading = true;
            var _this = this;
            var promiseArray = [];
            const promises = [Promise.resolve(), Promise.resolve()];
            window['apikey'] = this.key;
            if (navigator.onLine) {
                clearQueue(promises)
                .then(function () {
                    try {
                        return new Promise((resolve, reject) => {
                            _this.$http.get('//mobileservice.maalertjek.niras.dk/api/indstillinger')
                            .then((response) =>
                                resolve(response)
                            )
                            .catch((err) => 
                                _this.errorMessage = "Den angivne nøgle er forkert",
                                _this.downloading = false,
                                reject
                            )
                        })
                        .then(response => {
                            return response.body;
                        }, response => {
                            _this.errorMessage = "Den angivne nøgle er forkert"
                            _this.downloading = false;
                            return false;
                        })
                    } catch(err) {
                        console.log("err");
                        _this.errorMessage = "Der skete en fejl. Prøv venligst igen";
                    }
                })
                .then(function (data) {
                    if (data == undefined) {
                        _this.errorMessage = "Den angivne nøgle er forkert"
                        _this.downloading = false;
                    } else {
                        _this.downloading = true;
                        window['url'] = data.serviceUrl;
                        window['version'] = data.serviceVersion;
                        return DAL.setItem("MTSettings", "settings", data);
                    }
                })
                .then(function () {
                    return new Promise((resolve, reject) => {
                        _this.$http.get(window['url'] +'v' + window['version'] +'/lister/montoerer')
                        .then(response => resolve(response))
                        .catch(() => 
                            _this.errorMessage = "Der skete en fejl. Prøv venligst igen",
                            reject
                        )
                    })
                    .then(response => {
                        return response.body;
                    }, response => {
                        _this.errorMessage = "Den angivne nøgle er forkert"
                        _this.downloading = false;
                        return false;
                    })
                })
                .then(function (data) {
                    if (data == undefined) {
                        _this.errorMessage = "Den angivne nøgle er forkert"
                        _this.downloading = false;
                    } else {
                        _this.errorMessage = '';
                        _this.validated = true;
                        _this.options = data;
                        _this.step1 = false;
                        _this.step2 = true;
                        _this.step3 = false;
                        _this.errorMessage = "";
                        _this.downloading = false;
                        return DAL.setItem("MTUsers", "users", data);
                    }
                })
            } else {
                _this.errorMessage = "Du har ikke noget internet";
            }
        },
        chooseUser() {
            if (this.empty == false) {
                this.$cookie.set('url', window['url'], { expires: '20Y' })
                this.$cookie.set('version', window['version'], { expires: '20Y' })
                this.$cookie.set('apikey', window['apikey'], { expires: '20Y' });
                this.$cookie.set('user', JSON.stringify(window['user']), { expires: '20Y' });
                this.step1 = false;
                this.step2 = false;
                this.step3 = true;
                this.errorMessage = "";
            } else {
                this.errorMessage = "Vælg en bruger i listen";
            }
        },
        getServerData() {
            var _this = this;
            var promiseArray = [];
            this.showLoader = true;
            const promises = [Promise.resolve(), Promise.resolve()]

            // Check om der allerede findes noget i indexedDB
            // Slet hvis det findes

            if(navigator.onLine) {
                clearQueue(promises)
                .then(function () {
                    _this.activeStep = 1;
                    _this.message = "Dette kan tage lidt tid...";
                    try {
                        return new Promise((resolve, reject) => {
                            _this.$http.get(window['url'] +'v' + window['version'] +'/lister/allelister')
                            .then(response => resolve(response))
                            .catch(() => reject)
                        })
                        .then(response => {
                            return response.body;
                        }, response => {
                            this.message = "";
                            this.errorMessage = "Der opstod en fejl under installationen";
                            return false;
                        })
                    } catch(err) {
                        console.log("err", err)
                        _this.errorMessage = "Der skete en fejl. Prøv venligst igen";
                    }
                })
                .then(function (data) {
                    if (data == undefined) {
                        this.message = "";
                        this.errorMessage = "Der opstod en fejl under installationen";
                    } else {
                        var promiseArray = [];

                        data.bookinger.forEach(function (booking) {
                            promiseArray.push(function () {
                                return DAL.setItem("MTTasks", booking.id, booking).then(function () {
                                });
                            })
                        });

                        DAL.setItem("MTBookingTypes", "bookingtypes", data.bookingTyper);
                        DAL.setItem("MTTimeTypes", "timetypes", data.nyTidTyper);
                        DAL.setItem("MTNoteTypes", "notetypes", data.bemaerkningTyper);
                        DAL.setItem("MTPlacementTypes", "placementtypes", data.placeringTyper);

                        return clearQueue(promiseArray);
                    }
                })
                .then(function () {
                    _this.showLoader = false;
                    _this.message = "";
                    _this.$cookie.set('downloaded', true, {expires: '1Y'})
                    _this.$router.push({
                        name: 'projekter'
                    });
                });
            } else {
                _this.errorMessage = "Du har ikke noget internet";
            }
        }
    },
    watch: {
        selected (val, oldVal) {
            if (oldVal != val) {
                window['user'] = {navn: val.navn, id: val.id};
                if (val != '') {
                    this.empty = false;
                    this.errorMessage = '';
                } else {;
                    this.empty = true;
                }
            }
        }
    },
    mounted() {
        $(document).foundation();
        $('header').hide();

        console.log("mounted", this.$route.params.key)
        
        var _this = this;
        if(this.$route.params.key) {
            if (this.$cookie.get('apikey')) {
                console.log("got key from cookie")
                this.key = this.$cookie.get('apikey');
            }
            else if (this.$route.params.key != "Key") {
                this.key = this.$route.params.key;
            } else {
                this.key = "";
            }
        }
        
        if (this.$cookie.get('downloaded')) {
            _this.$router.push({
                name: 'projekter'
            });
        } else {
            console.log("app isn't downloaded");
        }
    }
}
</script>


// WEBPACK FOOTER //
// init.vue?079c3042